import { useTranslation } from "react-i18next";
import Box from "../../designSystem/Box";
import styles from "../../loader.module.css";

const LinearLoader = () => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        textAlign: "center"
      }}
    >
      <Box sx={{ width: "300px" }}>
        <span className={styles.loader}></span>
      </Box>
      {t("contentLibrary.editModal.hashtagTab.loading")}
    </Box>
  );
};

export default LinearLoader;
